import { clsx } from 'clsx'
import { useContext } from 'react'
import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

import type { TypeHorizontalAlignment } from '@contentful-types/alignment'

import { AlignmentContext } from '@contexts/alignment-context'

import { Column } from '@components/ui-core/column/column'
import { type CrossAxisAlignment } from '@components/ui-core/types'

const alignments: Record<TypeHorizontalAlignment, CrossAxisAlignment> = {
  left: 'start',
  right: 'end',
  default: 'center',
  centerContentLeftAlignText: 'center',
}

const alignmentToTextAlign: Record<TypeHorizontalAlignment, string> = {
  left: 'text-align-start',
  right: 'text-align-end',
  default: 'text-align-center',
  centerContentLeftAlignText: 'text-align-start',
}

export type SingleColumnLayoutProps = ComponentPropsWithoutRef<'div'>

export function SingleColumnLayout({
  children,
  className,
  ...rest
}: SingleColumnLayoutProps): ReactElement {
  const { horizontal } = useContext(AlignmentContext)

  return (
    <Column
      crossAxisAlignment={alignments[horizontal]}
      className={clsx(alignmentToTextAlign[horizontal], className)}
      data-horizontal-alignment={alignments[horizontal]}
      {...rest}
    >
      {children}
    </Column>
  )
}
